var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EFF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2339 26.0566C40.568 25.6805 39.7024 25.6805 38.9701 26.0566L33.7762 28.9396L30.2471 30.8199L25.0534 33.7029C24.3875 34.079 23.5219 34.079 22.7894 33.7029L18.6611 31.4466C17.9952 31.0705 17.5291 30.3812 17.5291 29.6291V25.1791C17.5291 24.427 17.9286 23.7376 18.6611 23.3615L22.7228 21.1679C23.3887 20.7919 24.2543 20.7919 24.9868 21.1679L29.0486 23.3615C29.7144 23.7376 30.1806 24.427 30.1806 25.1791V28.0622L33.7096 26.1192V23.2362C33.7096 22.4841 33.3102 21.7947 32.5777 21.4186L25.0534 17.282C24.3875 16.906 23.5219 16.906 22.7894 17.282L15.132 21.4186C14.3995 21.7947 14 22.4841 14 23.2362V31.572C14 32.3241 14.3995 33.0136 15.132 33.3896L22.7894 37.5262C23.4553 37.9022 24.3209 37.9022 25.0534 37.5262L30.2471 34.7057L33.7762 32.7628L38.9701 29.9424C39.6359 29.5664 40.5015 29.5664 41.2339 29.9424L45.2957 32.1361C45.9615 32.5121 46.4277 33.2016 46.4277 33.9537V38.4035C46.4277 39.1558 46.0282 39.8451 45.2957 40.2211L41.2339 42.4775C40.568 42.8535 39.7024 42.8535 38.9701 42.4775L34.9083 40.2839C34.2423 39.9078 33.7762 39.2183 33.7762 38.4663V35.5833L30.2471 37.5262V40.4092C30.2471 41.1612 30.6467 41.8507 31.3791 42.2268L39.0366 46.3633C39.7024 46.7394 40.568 46.7394 41.3005 46.3633L48.9581 42.2268C49.6239 41.8507 50.09 41.1612 50.09 40.4092V32.0733C50.09 31.3213 49.6904 30.6319 48.9581 30.2559L41.2339 26.0566Z",
    fill: "#8347E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonLogo);
export default __webpack_public_path__ + "static/media/polygon-logo.806fa3c73b11fd1ae16db58cf5ddb3c0.svg";
export { ForwardRef as ReactComponent };